import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'

const AreaArticuloGestion = lazy(() => import('./view/AreaArticuloGestion'))

export const areaArticuloRoutesMap = {
  gestion: {
    path: '/areas/articulos',
    name: 'Áreas por Artículo',
    action: 'GESTION_DE_AREAS',
  },
}

const areaArticuloRoutes = [
  {
    path: areaArticuloRoutesMap.gestion.path,
    element: <AreaArticuloGestion />,
    auth: authRoles.admin,
  },
]

export default areaArticuloRoutes
